// extracted by mini-css-extract-plugin
export default {"publish-date":"QwOC4O","publish-date__text":"oL7bIl"};